const languages = {
  ruRu: {
    short: 'ru-RU',
    long: 'Русский',
  },
};

export default languages;
